import { ChartNoAxesColumnIncreasing } from 'lucide-react';
import { cn } from '../lib/cn';

/** The mark: an accent square with a rising-bars glyph. */
export function Mark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex size-5 shrink-0 items-center justify-center rounded-md bg-accent',
        className,
      )}
    >
      <ChartNoAxesColumnIncreasing className="size-3.5 text-on-solid" />
    </span>
  );
}

/** The product name is a brand, not translated. */
const BRAND = 'Botimir';

export function Wordmark({ className }: { className?: string }) {
  return <span className={cn('text-sm font-semibold text-text-1', className)}>{BRAND}</span>;
}
